import { useId, useState } from "react";
import { STANDS_CROQUIS } from "./plan-salon.ts";
import "./plan-salon.css";

export function PlanSalon3D(): React.ReactElement {
  const titreId = useId();
  const [selection, setSelection] = useState("");
  const [rotation, setRotation] = useState(-12);
  const [zoom, setZoom] = useState(85);
  const [dessus, setDessus] = useState(false);
  return (
    <section className="card plan-salon" aria-labelledby={titreId}>
      <header className="plan-salon-entete">
        <p className="eyebrow">Aperçu · Croquis 2026</p>
        <h2 className="display" id={titreId}>Explorer le salon</h2>
        <p>Une première vue à partir du croquis de Paul. Numéros provisoires ; noms, dimensions et catégories à confirmer. Ce plan ne représente pas l’édition 2027.</p>
      </header>
      <div className="plan-salon-commandes">
        <button className="btn btn-ghost" type="button" aria-pressed={dessus} onClick={() => setDessus(!dessus)}>Vue de dessus</button>
        <label>Rotation <input type="range" min="-45" max="45" value={rotation} onChange={(e) => setRotation(Number(e.target.value))} /> {rotation}°</label>
        <label>Zoom <input type="range" min="60" max="130" value={zoom} onChange={(e) => setZoom(Number(e.target.value))} /> {zoom}%</label>
        <button className="btn btn-ghost" type="button" onClick={() => { setRotation(-12); setZoom(85); setDessus(false); }}>Recentrer</button>
      </div>
      <div className="plan-salon-fenetre">
        <div className="plan-salon-scene" style={{ transform: `rotateX(${dessus ? 0 : 40}deg) rotateZ(${rotation}deg) scale(${zoom / 100})` }}>
          <div className="plan-salon-sol" />
          {STANDS_CROQUIS.map((stand) => (
            <button key={stand.id} type="button" className="plan-salon-stand" aria-label={`Stand provisoire ${stand.id}`} aria-pressed={selection === stand.id}
              style={{ left: `${stand.x / 9.63}%`, top: `${stand.y / 6.8}%`, width: `${stand.largeur / 9.63}%`, height: `${stand.profondeur / 6.8}%` }}
              onClick={() => setSelection(selection === stand.id ? "" : stand.id)}>{stand.id}</button>
          ))}
        </div>
      </div>
      <div className="plan-salon-details">
        <label className="field">Choisir un stand
          <select className="select" value={selection} onChange={(e) => setSelection(e.target.value)}>
            <option value="">Sélectionner sur le plan ou dans la liste</option>
            {STANDS_CROQUIS.map((s) => <option key={s.id} value={s.id}>Stand provisoire {s.id}</option>)}
          </select>
        </label>
        <p role="status">{selection ? `Stand ${selection} — nom, surface, catégorie et disponibilité à confirmer.` : "Sélectionnez un stand pour le repérer. Cette maquette ne réserve aucun emplacement."}</p>
      </div>
    </section>
  );
}
